import Timestamp from "components/Timestamp";

import { CellComponentProps } from "./types";

type BlueprintsRowUpdatedAtCellProps = CellComponentProps;

const BlueprintsRowUpdatedAtCell = ({ blueprint }: BlueprintsRowUpdatedAtCellProps) => {
  return <Timestamp timestamp={blueprint.updatedAt} />;
};

export default BlueprintsRowUpdatedAtCell;
